import React, { Fragment, useEffect, useCallback } from 'react';
import ReactDOM from 'react-dom';
import { isEmpty, keys } from 'lodash-es';

import TopSdksTable from '../components/TopSdksTable';
import Header from '../../shared/components/Header';
import RelatedAppStoreAnalitics from '../../shared/components/RelatedAppStoreAnalitics';
import TopChartsFilters from '../../shared/components/TopChartsFilters';
import LoadingOverlay from '../../../../../components/LoadingOverlay';
import { initParams, parseUrlForFilters } from '../configs';
import helpers from '../../../../../utils/helpers';

// Static configs
const { report, shareOptions, generalData, data } = initParams();
const enableTopFilters = ['store', 'sdks_functions'];

const PageContainer = () => {
  useEffect(() => {
    const onPopstate = () => window.location.reload();
    window.addEventListener('popstate', onPopstate);
    return () => window.removeEventListener('popstate', onPopstate);
  }, []);
  const baseUrl = ({ store, function_id }) =>
    `${window.location.origin}/top-charts/top-sdks/${store}/${function_id}`;
  const p = parseUrlForFilters();

  const handleFilterChange = useCallback((filter) => {
    const defaultParsedURL = !filter.store && keys(p).length === 1 && p.store === undefined;
    const defaultStore =
      (filter.store && (filter.store === 'itunes-connect' || filter.store === 'itunes_connect')) ||
      defaultParsedURL ||
      (!filter.store && p.store === 'itunes-connect');
    const defaultFilters = {
      function_id: SDK_FUNCTIONS[filter.function_id] || p.function_id,
      store: defaultStore ? 'itunes-connect' : 'google-play',
    };

    const allFilters = {
      store: filter.store || defaultParsedURL ? defaultFilters.store : p.store,
      function_id:
        helpers.convertToSlug(SDK_FUNCTIONS[filter.function_id]) ||
        (filter.function_id !== 'all' && defaultFilters.function_id) ||
        'all',
    };
    window.location.assign(`${baseUrl(allFilters)}`);
  }, []);

  const handleShowMore = useCallback(() => {
    document.getElementById('schedule-a-demo-modal').classList.add('in');
  }, []);

  const childComponent = <RelatedAppStoreAnalitics store={report.store} type="SDKs" />;
  const renderPortal = () =>
    ReactDOM.createPortal(childComponent, document.getElementById('related-apps-store-analytics'));

  const headline = (
    <span>
      Most Used <span className="text-blue">SDKs</span> For {generalData.default_os_name} Mobile
      Apps
    </span>
  );

  const subheadline = `Free list of top SDK for ${generalData.store_name}`;

  return (
    <Fragment>
      <LoadingOverlay loading={isEmpty(report)} />
      <Fragment>
        <Header headline={headline} subheadline={subheadline} />
        <section className="top-charts-publishers-content container">
          <TopChartsFilters
            onFilterChange={handleFilterChange}
            filters={data}
            enableTopFilters={enableTopFilters}
            shareOptions={shareOptions}
          />
          <TopSdksTable report={report} onShowMore={handleShowMore} />
        </section>
      </Fragment>
      {renderPortal()}
    </Fragment>
  );
};

export default PageContainer;
